export const PaymentLogicOptions = [
  { label: "Przed spotkaniem", value: 3 },
  { label: "Po spotkaniu", value: 4 },
  { label: "Na początku miesiąca", value: 2 },
  { label: "Na koniec miesiąca", value: 1 },
  { label: "Nie wyznaczaj terminu płatności", value: 0 },
];
